export const BASE_URL = "https://allfourcar.com/admin/api/"
export const IMG_URL = "https://allfourcar.com/admin/public/images/logo/"